import { c as _c } from "react/compiler-runtime";
import CommonSelect from "@/components/utils/select/CommonSelect";
import CommonDropdown from "@/components/utils/select/dropdown/CommonDropdown";
import type { SortDirection } from "@/entities/ISort";
import type { XtdhTokensSortField } from "@/hooks/useXtdhTokensQuery";
import { TOKEN_CONTRIBUTORS_GROUP_BY_ITEMS, TOKENS_SORT_ITEMS, type XtdhTokenContributorsGroupBy } from "@/components/xtdh/received/constants";
interface XtdhTokenContributorsControlsProps {
  readonly activeSortField: XtdhTokensSortField;
  readonly activeSortDirection: SortDirection;
  readonly activeGroupBy: XtdhTokenContributorsGroupBy;
  readonly onSortChange: (sort: XtdhTokensSortField) => void;
  readonly onGroupByChange: (groupBy: XtdhTokenContributorsGroupBy) => void;
  readonly isDisabled?: boolean | undefined;
}
export function XtdhTokenContributorsControls(t0) {
  const $ = _c(13);
  const {
    activeSortField,
    activeSortDirection,
    activeGroupBy,
    onSortChange,
    onGroupByChange,
    isDisabled: t1
  } = t0;
  const isDisabled = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== activeSortDirection || $[1] !== activeSortField || $[2] !== isDisabled || $[3] !== onSortChange) {
    t2 = <div className="tw-w-full md:tw-w-auto"><CommonSelect items={TOKENS_SORT_ITEMS} activeItem={activeSortField} filterLabel="Sort contributors by" setSelected={onSortChange} sortDirection={activeSortDirection} disabled={isDisabled} fill={false} /></div>;
    $[0] = activeSortDirection;
    $[1] = activeSortField;
    $[2] = isDisabled;
    $[3] = onSortChange;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="tw-text-sm tw-font-semibold tw-text-iron-400 tw-whitespace-nowrap">Group by</span>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== activeGroupBy || $[7] !== isDisabled || $[8] !== onGroupByChange) {
    t4 = <div className="tw-flex tw-items-center tw-gap-3 tw-w-full md:tw-w-auto">{t3}<div className="tw-w-full md:tw-w-48"><CommonDropdown items={TOKEN_CONTRIBUTORS_GROUP_BY_ITEMS} activeItem={activeGroupBy} filterLabel="Group contributors by" setSelected={onGroupByChange} disabled={isDisabled} /></div></div>;
    $[6] = activeGroupBy;
    $[7] = isDisabled;
    $[8] = onGroupByChange;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t4) {
    t5 = <section className="tw-flex tw-flex-col tw-gap-4" aria-label="Filter token contributors"><div className="tw-flex tw-flex-col tw-gap-3 md:tw-flex-row md:tw-items-center md:tw-justify-between"><div className="tw-flex tw-w-full tw-flex-col tw-gap-3 md:tw-flex-row md:tw-items-center md:tw-justify-between">{t2}{t4}</div></div></section>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}